<template>
  <v-dialog
    v-model="openDialog"
    :maxWidth="maxWidth"
    persistent
    :fullscreen="fullscreen"
    scrollable
  >
    <v-card
      class="rounded-xl"
      :class="{ dialog: !noBorder }"
      v-show="!isLoading"
      style="position: relative"
    >
      <v-toolbar
        class="pt-2 px-3"
        height="64"
        :style="{
          backgroundColor: backgroundColor,
        }"
      >
        <MySvg
          v-if="titleIcon"
          :icon="titleIcon"
          :svg-max-width="30"
          :svg-max-height="30"
          class="pe-1 mt-1"
          :color="titleIconColor"
        />
        <span
          class="align-center text-h6"
          style="font-family: 'Fredoka'; font-weight: 400"
          >{{ title }}</span
        >
        <v-spacer />
        <slot name="toolbar" />
        <v-btn
          v-if="!noExit"
          size="small"
          icon
          variant="text"
          @click="openDialog = false"
        >
          <MySvg svgMaxWidth="30" svg-max-height="30" icon="close-square" />
        </v-btn>
      </v-toolbar>
      <v-sheet
        class="overflow-hidden overflow-y-auto my-scrollbar flex-grow-1"
        :max-height="maxHeightComputed"
        :min-height="minHeightComputed"
        :style="{ backgroundColor: backgroundColor }"
      >
        <v-container :fill-height="fillHeight" fluid>
          <slot name="content" />
        </v-container>
      </v-sheet>
      <v-card-actions v-if="showActions" class="bg-white">
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { color } from 'echarts'

export default {
  name: 'BaseDialog',
  props: {
    modelValue: Boolean,
    title: String,
    titleIcon: String,
    maxHeight: { type: Number, default: 600 },
    minHeight: { type: Number, default: 200 },
    fillHeight: { type: Boolean, default: true },
    maxWidth: { type: Number, default: 1100 },
    fullscreen: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    noBorder: { type: Boolean, default: false },
    noExit: { type: Boolean, default: false },
    showActions: { type: Boolean, default: false },
    backgroundColor: { type: String, default: 'white' },
    titleIconColor: { type: String, default: 'unset' },
  },
  data: () => ({}),
  computed: {
    minHeightComputed() {
      if (this.fullscreen) return 'calc(100vh - 63px)'
      return `min(${this.minHeight}px, 60vh)`
    },
    maxHeightComputed() {
      if (this.fullscreen) return 'calc(100vh - 63px)'
      return `min(${this.maxHeight}px, 80vh)`
    },
    openDialog: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      },
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.v-toolbar__content) {
  height: 40px !important;
  padding: 0;
  .v-card__title {
    padding: 0;
  }
}
.dialog {
  border: 3px solid transparent; /*2*/
  background:
    linear-gradient(#ccc 0 0) padding-box,
    var(--linearHotPinkDodgerBlue) border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 100%;
  font-family: Fredoka;
}
:deep(.v-dialog) {
  box-shadow: none;
  overflow: hidden;
}
</style>
